import styled from 'styled-components'
import theme from 'styles/theme'
import { Body16 } from 'components/Typography'
import { transitions } from 'polished'

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: ${theme.maxWidths[1]};
  width: auto;
  margin: 0 auto;
  justify-content: center;
`

export const Method = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  :not(:last-child) {
    margin-right: ${theme.space[6]};
  }

  a {
    ${transitions('border-color ease-in 0.2s')};

    border-bottom: 1px solid transparent;
    text-decoration: none;

    color: ${theme.colors.sagedark};

    &:hover,
    &:focus {
      border-color: currentColor;
    }
  }
`

export const MethodIcon = styled.div`
  height: 42px;
  width: 42px;
  align-items: center;
  justify-content: center;
  display: flex;
  margin-right: ${theme.space[1]};
`

export const MethodLabel = styled(Body16)`
  color: ${theme.colors.sagemedium};
`
